import classNames from "classnames"

// Components
import { TextMessage } from "@mobi/ds"
import If from "@mobi/components/If"

// Styles
import "./Input.scss"

const Input = ({
  label,
  icon,
  description,
  rightIcon,
  isValid = true,
  errorMessage,
  customErrorMessage = false,
  className,
  type = "text",
  disabled,
  readOnly,
  autoComplete = "off",
  ...props
}) => {
  delete props?.maskChar

  const { "aria-required": ariaRequired, required } = props
  return (
    <div
      className={classNames("ds-input", className, {
        "ds-input--invalid": !isValid,
        "ds-input--disabled": disabled,
        "ds-input--readOnly": readOnly,
      })}
    >
      <label
        className="ds-input__label"
        htmlFor={`ds-field-${props.name}`}
        id={`ds-label-${props.name}`}
        dangerouslySetInnerHTML={{ __html: label }}
        aria-label={description ? `${label} - ${description}` : label}
        aria-hidden
      />
      <div className="ds-input__field">
        <input
          id={`ds-field-${props.name}`}
          type={type}
          aria-labelledby={`ds-label-${props.name}`}
          aria-required={ariaRequired || required}
          aria-invalid={!isValid}
          autoComplete={autoComplete}
          disabled={disabled}
          readOnly={readOnly}
          {...(!isValid && errorMessage
            ? { "aria-describedby": `ds-error-message-${props.name}` }
            : "")}
          {...props}
        />
        <div
          className="ds-input__icon ds-input__icon--right"
          aria-hidden="true"
        >
          {rightIcon}
        </div>
      </div>
      <TextMessage
        message={customErrorMessage}
        id={`ds-error-message-${props.name}`}
        show={customErrorMessage}
      />
      <TextMessage
        message={errorMessage}
        id={`ds-error-message-${props.name}`}
        show={!isValid}
      />
      <If
        condition={isValid && description}
        renderIf={
          <p className="ds-input__message ds-input__message--description">
            {description}
          </p>
        }
      />
    </div>
  )
}

export default Input
